import { useNavigate } from "react-router-dom";
import { Dropdown } from "../ui/Dropdown";
import { DropdownItem } from "../ui/DropdownItem";

export default function UserDropdown({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    // Remove token
    localStorage.removeItem("token");

    // Remove user if stored
    localStorage.removeItem("user");

    // Redirect login
    navigate("/signin");

    onClose();
  };

  return (
    <Dropdown isOpen={isOpen} onClose={onClose} className="w-44">
      
      <DropdownItem onItemClick={() => handleNavigate("/profile")}>
        Profile
      </DropdownItem>

      {/* <DropdownItem onItemClick={() => handleNavigate("/settings")}>
        Settings
      </DropdownItem> */}

      <div className="border-t my-1" />

      <DropdownItem
        className="text-red-500 hover:bg-red-50 "
        onItemClick={handleLogout}
      >
        Logout
      </DropdownItem>

    </Dropdown>
  );
}